<template>
    <Layout main="Reports" sub="custom">
        <section class="flex flex-col">
            <div class="flex flex-row w-full justify-between items-center">
                <div class="flex flex-col w-1/2">
                    <h1
                        class="w-full text-semibold text-[24px] hover:border-0 focus:ring-0 focus:border-0 border-0 bg-transparent"
                    >
                        My Reports
                    </h1>
                </div>
                <div class="flex flex-row space-x-[12px]">
                    <button
                        @click="addWeekly"
                        type="button"
                        class="inline-flex transition ease-in-out duration-300 space-x-[4px] items-center px-8 py-2 border border-transparent shadow-md shadow-purple-500/50 text-[14px] font-semibold rounded-md text-white bg-purple-500 hover:bg-purple-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                    >
                        <span>Add Weekly Report</span>
                    </button>
                    <button
                        @click="open"
                        type="button"
                        class="inline-flex transition ease-in-out duration-300 space-x-[4px] items-center px-8 py-2 border border-transparent shadow-md shadow-face-red/50 text-[14px] font-semibold rounded-md text-white bg-face-red hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-face-red"
                    >
                        <span>Create</span>
                    </button>
                </div>
            </div>

            <div>
                <AddCustomReportCard @create="open" v-if="!items.length" />
                <div
                    class="lg:w-full md:w-10/12 w-full flex flex-col items-center"
                >
                    <template v-for="report in items">
                        <CustomReportCard
                            @remove="handleRemove"
                            :report="report"
                        />
                    </template>
                </div>
            </div>

            <CreateModal @close="close" v-if="showCreate" />
        </section>
    </Layout>
</template>

<script setup>
import Layout from "@/Shared/Layout";
import CustomReportCard from "@/Shared/CustomReportCard";
import CreateModal from "./CreateModal.vue";
import AddCustomReportCard from "@/Shared/AddCustomReportCard";
import { onMounted, ref, computed } from "vue";

const props = defineProps({ reports: Array });
const items = ref([]);
const showCreate = ref(false);

onMounted(() => (items.value = props.reports));

const hasWeekly = computed(
    () => items.value.filter((report) => report.query_type === "weekly").length
);

const addWeekly = async () => {
    try {
        const response = await axios.post("/reports/custom/weekly");
        items.value.push(response.data);
    } catch (e) {}
};

const close = () => {
    showCreate.value = false;
};

const open = () => {
    showCreate.value = true;
};

const handleRemove = (id) => {
    items.value = items.value.filter((item) => item.id !== id);
};
</script>
